import React from 'react';

export type TypePushCalendar = 'all' | 'reminders' | 'none';

const KEY = 'bd-push-calendar';

const DEFAULT: TypePushCalendar = 'all';

const listeners = new Set<() => void>();

const parse = (raw: string | null): TypePushCalendar => (raw === 'reminders' || raw === 'none' ? raw : DEFAULT);

const load = (): TypePushCalendar => {
    try {
        return parse(window.localStorage.getItem(KEY));
    } catch {
        return DEFAULT;
    }
};

let value: TypePushCalendar = typeof window === 'undefined' ? DEFAULT : load();

export const getPushCalendar = (): TypePushCalendar => value;

export const setPushCalendar = (next: TypePushCalendar): void => {
    value = parse(next);
    try {
        window.localStorage.setItem(KEY, value);
    } catch {
        return;
    } finally {
        listeners.forEach((listener) => listener());
    }
};

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
};

export const usePushCalendar = (): TypePushCalendar => React.useSyncExternalStore(subscribe, getPushCalendar, () => DEFAULT);
